import $ from 'jquery';

export function renderAutocomplete() {
	function split(val) {
		return val.split(' ');
	}

	function extractLast(term) {
		return split(term).pop();
	}

	const searchTextElement = $('#searchText');
	searchTextElement
		.autocomplete({
			source: function (request, response) {
				// delegate back to autocomplete, but extract the last term
				response($.ui.autocomplete.filter(window.RBS_SD.config.taglist, extractLast(request.term)));
			},
			focus: function () {
				// prevent value inserted on focus
				return false;
			},
			select: function (e, ui) {
				const terms = split(this.value);
				// remove the current input
				terms.pop();
				// add the selected item
				terms.push(ui.item.value);
				// add placeholder to get the comma-and-space at the end
				terms.push('');
				this.value = terms.join(' ');
				return false;
			},
			minLength: 0,
			appendTo: searchTextElement.parent(),
		})
		.on('click', function () {
			searchTextElement.autocomplete('search', searchTextElement.val());
		});

	searchTextElement
		.wrap('<span class="inputDeleteIcon" />')
		.after(
			$('<span />')
				.on('click', function () {
					searchTextElement.val('').focus();
				})
		);
}
